(function(){
    'use strict';
    

    if($('.bq__ct__link-tile-carousel').length > 0) {

        var sliders = $('.content__main:not(.col-md-6) .bq__ct__link-tile-carousel .bq__ct__link-tile-carousel__items, .bq_timeline_page .bq__ct__link-tile-carousel .bq__ct__link-tile-carousel__items');
        if(sliders.length > 0){
            sliders.each(function(){
                var _prevArrow = $(this).parent().find('.bq__ct__link-tile-carousel__prev');
                
                var _nextArrow = $(this).parent().find('.bq__ct__link-tile-carousel__next');
                $(this).slick({
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    accessibility: false,
                    prevArrow: _prevArrow,
                    nextArrow: _nextArrow,
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }  
                    }]
                });
            });
        }
/*
        $('.content__main:not(.col-md-6) .bq__ct__link-tile-carousel .bq__ct__link-tile-carousel__items, .bq_timeline_page .bq__ct__link-tile-carousel .bq__ct__link-tile-carousel__items').slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            accessibility: false,
            prevArrow: $(this).find('.bq__ct__link-tile-carousel__prev'),
            nextArrow: $(this).find('.bq__ct__link-tile-carousel__next'),
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }  
            }]
        });*/

        var smallSliders = $('.col-md-6 .bq__ct__link-tile-carousel .bq__ct__link-tile-carousel__items');

        if(smallSliders.length > 0){
            smallSliders.each(function(){
                var _prevArrow = $(this).parent().find('.bq__ct__link-tile-carousel__prev');
                
                var _nextArrow = $(this).parent().find('.bq__ct__link-tile-carousel__next');
                $(this).slick({
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false,
                    accessibility: false,
                    prevArrow: _prevArrow,
                    nextArrow: _nextArrow,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }  
                    }]
                });
            });
        }

                

/*
        $('.col-md-6 .bq__ct__link-tile-carousel .bq__ct__link-tile-carousel__items').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            accessibility: false,
            prevArrow: $(this).find('.bq__ct__link-tile-carousel__prev'),
            nextArrow: $(this).find('.bq__ct__link-tile-carousel__next'),
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }  
            }]
        });*/
    }
}());
